import { Box, Grid, Button } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { ContentContainer, FormSubsection, FormikTextField, FormikAutocomplete } from "components";
import { FormikContextType, FormikProvider } from "formik";
import { useCodes } from "hooks";
import { useTranslation } from "react-i18next";
import { selOptions } from "utilities";

type Props = {
  formik: FormikContextType<any>;
  loadingSave: boolean;
};

const MetadataSearchForm = (props: Props) => {
  const { formik, loadingSave } = props;
  const { handleSubmit, handleReset, dirty, isValid } = formik;
  const { t } = useTranslation("telemetry"); // Get translation

  // Fetch autocomplete codes
  const { codes, loadingCodes } = useCodes(["sorg"]);

  return (
    <>
      <FormikProvider value={formik}>
        <form className="h-100" onSubmit={handleSubmit}>

          {/* Fixed Header */}
          <Box sx={{
            py: 1.5,
            borderBottom: 1,
            borderBottomColor: "grey.300",
            backgroundColor: "grey.50",
          }}>
            <ContentContainer>
              <Grid container spacing={3} flexWrap="nowrap" alignItems="right">
                <Grid item xs="auto">

                  {/* Discard changes button */}
                  {dirty && !loadingSave &&
                    <Button
                      color="error"
                      startIcon={<CloseOutlinedIcon />}
                      sx={{
                        mr: 4
                      }}
                      onClick={handleReset}
                    >
                      Reset Form
                    </Button>
                  }

                  {/* Save button */}
                  <LoadingButton
                    variant="contained"
                    type="submit"
                    startIcon={<SearchOutlinedIcon />}
                    disabled={loadingSave || loadingCodes}
                    loading={loadingSave}>
                    Search
                  </LoadingButton>

                </Grid>
              </Grid>
            </ContentContainer>
          </Box>

          <ContentContainer py={1}>

            <FormSubsection title={t("Search Criteria")}>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <FormikAutocomplete
                    name="sorg"
                    label={t("Sales Org")}
                    options={selOptions(codes, "sorg")}
                    loading={loadingCodes}
                  />
                </Grid>
                <Grid item xs={4}>
                  <FormikTextField
                    type="text"
                    name="hoursSinceLastSeen"
                    label={t("No call in since (hours)")}
                    required={true}
                  />
                </Grid>
                <Grid item xs={2}>
                  <FormikTextField
                    type="text"
                    name="limit"
                    label={t("Record Limit")}
                  />
                </Grid>
                <Grid item xs={8}>
                  <FormikTextField
                    type="text"
                    name="deviceid"
                    label={t("Telemetry Device ID")}
                  />
                </Grid>
              </Grid>
            </FormSubsection>

          </ContentContainer>
        </form>
      </FormikProvider>
    </>
  );
};

export default MetadataSearchForm;
